import Vue from "vue"
import {
    dateFormat,
    numberToChinese
} from '@js/index'

Vue.filter("dateFormat",function(value,fmt){
    if(!value) return "";
    return dateFormat(value,fmt);
})
Vue.filter("numberToChinese",function(value){
    if(!value) return "";
    return numberToChinese(value);
})
Vue.filter("replenish",function(value,min=2){
    if(!value) return "";
    value = ''+value;
    if(value.length < min){
        let str='';
        for(var i=0;i<min;i++)str+='0';
        return (str + value).substr((value).length);
    }else{
        return value;
    }
})